import React, { useState } from "react";
import { PopulationTrend } from "../common/ObjectTypes";
import { AddIcon, DeleteIcon } from "../common/ProjectIcons";
import TextInput from "../common/TextInput";

type PopulationTrendProps = {
  populationTrends: PopulationTrend[];
  selectedTrend: PopulationTrend;
  trendToAdd: PopulationTrend;
  addTrend: boolean;
  onSelectTrend: Function;
  onClickAdd: Function;
  onCancelEdit: Function;
  onCancelAdd: Function;
  onChange: Function;
  onChangeNewTrend: Function;
  onSaveNew: Function;
  onUpdateTrend: Function;
  onDelete: Function;
};

const PopulationTrendController = ({
  populationTrends,
  selectedTrend,
  trendToAdd,
  addTrend,
  onSelectTrend,
  onClickAdd,
  onCancelEdit,
  onCancelAdd,
  onChangeNewTrend,
  onChange,
  onSaveNew,
  onUpdateTrend,
  onDelete,
}: PopulationTrendProps) => {
  return (
    <div className="pt-6 bg-newGray-500 bg-opacity-50 px-6 ">
      <div className="flex flex-row justify-center">
        <div className="w-3/5">
          <h1 className="text-4xl text-center font-medium">Population Trend</h1>

          <div className="drop-shadow-lg mt-6 bg-white bg-opacity-70 h-50 p-2 overflow-scroll">
            <table className="w-full">
              <tbody>
                {populationTrends.map(
                  (trend: PopulationTrend, index: number) => {
                    // Apply a different CSS class based on whether the index is odd or even
                    const rowClass =
                      index % 2 === 0 ? "bg-grayScale-400" : "bg-grayScale-200";

                    return (
                      <tr key={trend.id} className={"" + rowClass}>
                        <td className="p-2 w-full">{trend.name}</td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopulationTrendController;
